/**
 * 페이지 복제본 렌더링용 초기 데이터 (홈페이지 원본 데이터와 동일한 형태).
 * 적용 분야(chapters/faqs)는 이미 작성한 siteContent를 재사용합니다.
 */
import { SITE_CONTENT } from '../data/siteContent';

const appsPage = SITE_CONTENT.find((p) => p.id === 'applications');
export const APP_CHAPTERS = appsPage.sections[0].fields[0].value;
export const APP_FAQS = appsPage.sections[1].fields[0].value;

/* ── 솔루션(응용 분야) 카드 ── */
export const SOLUTIONS = [
  { slug: 'military', title: '국방 & 항공우주', subtitle: 'Defense-Grade Computing', desc: '정밀 타격, C2, 감시, 무인 체계 등 가장 가혹한 운용 환경을 위해 설계된 견고한 VPX/VME 보드 및 신호 처리 플랫폼.', image: '/images/services/military-aerospace.png' },
  { slug: 'railway', title: '철도 교통', subtitle: 'SIL4 Safety Systems', desc: 'CBTC, 연동(interlocking), 열차 제어를 위한 TÜV SÜD SIL4 인증 HIMA ControlSafe™ 플랫폼 — 철도 신호 분야 최고 수준의 안전 무결성을 제공합니다.', image: '/images/services/railway.png' },
  { slug: 'industrial', title: '산업 자동화', subtitle: 'Industrial-Grade Platforms', desc: '공장 자동화, 공정 제어, 반도체 제조, 품질 검사를 위한 팬리스 산업용 PC, 네트워크 어플라이언스, IoT 플랫폼.', image: '/images/services/industrial.png' },
  { slug: 'telecom', title: '통신 & 네트워킹', subtitle: 'Network Infrastructure', desc: '방화벽, VPN, UTM, 로드 밸런싱을 위한 Intel/AMD 기반 네트워크 어플라이언스와 데이터센터·통신 인프라용 고성능 NIC 어댑터.', image: '/images/services/industrial.png' },
  { slug: 'sensor', title: '센서 모델링 & 시뮬레이션', subtitle: 'OKTAL-SE Solutions', desc: 'HWIL(Hardware-In-the-Loop), MITL(Man-In-the-Loop), 훈련 시뮬레이션 환경을 위한 OKTAL-SE의 고정밀 EO/IR/RF 센서 시뮬레이션.', image: '/images/services/military-aerospace.png' },
  { slug: 'ipc', title: '산업용 PC (IPC)', subtitle: 'Industrial PCs', desc: '박스형 PC, 랙마운트, 서버, 데스크탑, 월마운트, 패널 PC 등 다양한 산업 환경에 최적화된 견고한 산업용 컴퓨터.', image: '/images/services/military-aerospace.png' },
];

/* ── 홈 "제품 소개" 카드 ── */
export const FEATURED_PRODUCTS = [
  { name: 'Industrial PCs & Fanless Industrial PCs', spec: 'Boxtype · Rackmount · Server · Desktop · Wallmount · Panel', image: '/images/products/fanless-pc.png' },
  { name: 'Form Factor — Abaco Systems', spec: 'VME · VPX 3U/6U · CompactPCI · PMC · XMC · FMC/FMC+', image: '/images/products/form-factor.png' },
  { name: 'High Performance Computing', spec: 'Servers · Desktop · GPU Appliances · GPU Expansion · Video Acceleration', image: '/images/products/hpc-servers.png' },
  { name: 'HIMA Railway Safety System', spec: 'HiMax · HiMatrix · ControlSafe™ Platform · SIL3/SIL4', image: '/images/products/hima-railway.png' },
  { name: 'RAM Module 16GB', spec: 'test', image: '/images/products/ram-module.png' },
  { name: 'CPU Processor', spec: 'test', image: '/images/products/cpu-processor.png' },
  { name: 'HDD 2TB', spec: 'test', image: '/images/products/hdd-2tb.png' },
  { name: 'Motherboard', spec: 'test', image: '/images/products/motherboard.png' },
];

/* ── 홈 "적용 분야" 아코디언 ── */
export const SOLUTION_ACCORDION = [
  { id: 'acc-basic', title: '임베디드 컴퓨팅', body: 'Jade, Cobalt, Onyx, Talon, Flexor, Spark 플랫폼을 포함한 보드 레벨 신호 처리 시스템으로, 까다로운 국방·항공우주 환경을 위해 설계되었습니다.' },
  { id: 'acc-inter', title: '산업 & 네트워킹', body: 'KC 인증 및 ISO 9001을 준수하는 팬리스 PC, 랙마운트 서버, 네트워크 어플라이언스로, 가혹한 산업 환경에서 24시간 연속 운용을 위해 제작되었습니다.' },
  { id: 'acc-adv', title: '안전 필수 시스템', body: '철도 신호 및 열차 제어를 위한 TÜV SÜD SIL4 인증 HIMA ControlSafe™ 플랫폼 — 페일세이프 내결함성 아키텍처로 최고 수준의 운용 안전성을 보장합니다.' },
  { id: 'acc-telecom', title: '통신 & 네트워킹', body: '방화벽, VPN, UTM, 로드 밸런싱을 위한 Intel/AMD 기반 네트워크 어플라이언스와 데이터센터·통신 인프라용 고성능 NIC.' },
  { id: 'acc-sensor', title: '센서 모델링 & 시뮬레이션', body: 'HWIL(Hardware-In-the-Loop), MITL(Man-In-the-Loop), 훈련 시뮬레이션 환경을 위한 OKTAL-SE의 고정밀 EO/IR/RF 센서 시뮬레이션.' },
  { id: 'acc-hpc', title: '고성능 컴퓨팅 (HPC)', body: '머신러닝, 금융 분석, 군사, 의료 영상, 과학 연구를 위한 고밀도 GPU 서버 및 PCIe 확장 시스템.' },
];

/* ── 홈 "토탈 서비스 솔루션" 플랜 ── */
export const PLANS = [
  { title: '컨설팅 & 설계', step: 'Step 1–2', period: '고객 컨설팅 · 설계 컨설팅', desc: '프로젝트 요구사항을 분석하고 맞춤형 시스템 설계를 수립하여, 처음부터 최적의 하드웨어·소프트웨어·통합 방식을 보장합니다.', image: '/images/plans/plan-standard.png' },
  { title: '구축 & 지원', step: 'Step 3–4', period: '시스템 구축 · 기술 지원', desc: '조달과 시스템 구축을 안내하고, 프로젝트 전 주기에 걸쳐 구축된 솔루션에 대한 실질적인 기술 지원을 제공합니다.', image: '/images/plans/plan-premium.png' },
  { title: '검증 & 검사', step: 'Step 5', period: '제품 평가 · 품질 보증', desc: '납품되는 모든 시스템이 프로젝트 사양, 업계 표준, 성능 기준을 충족하는지 엄격한 시험과 평가로 검증합니다.', image: '/images/plans/plan-enterprise.png' },
];

/* ── 홈 하단 파트너 로고 ── */
export const HOME_PARTNERS = [
  { src: '/images/partners/abaco.png', label: 'Abaco Systems' },
  { src: '/images/partners/hima.png', label: 'HIMA Railway' },
  { src: '/images/partners/windriver.png', label: 'Wind River' },
  { src: '/images/partners/oss.png', label: 'One Stop Systems' },
  { src: '/images/partners/rti.png', label: 'RTI' },
  { src: '/images/partners/oktalse.png', label: 'OKTAL-SE' },
  { src: '/images/partners/cambridge-pixel.png', label: 'Cambridge Pixel' },
  { src: '/images/partners/pentek.png', label: 'Pentek' },
];

/* ── 히어로 슬라이드 ── */
export const HERO_SLIDES = [
  { src: '/images/services/industrial.png', eyebrow: '우수한 성능 및 맞춤형 서비스를 위한 KC 인증 · ISO 9001 품질 경영 시스템', title: '산업용 팬리스 PC Solution', desc: '구체적인 요구사항을 정확하게 반영한 시스템 플랫폼 솔루션으로 제공합니다.' },
  { src: '/images/services/railway.png', eyebrow: '철도 제어 및 신호 적용을 위한 SIL4 인증 COTS Fail-Safe & Fault-Tolerant System', title: 'ControlSafe™ Platforms', desc: 'TÜV SÜD로부터 SIL4 인증을 받은 ControlSafe™ 플랫폼을 제공합니다.' },
  { src: '/images/services/military-aerospace.png', eyebrow: '30년 이상 국내 군수·항공 시장에서 선두 주자 역할을 해온 고가용성 시스템', title: 'Embedded Solution', desc: 'Embedded Solution, M&S Solution, Middleware Solution, RTOS 등 우수한 제품을 제공합니다.' },
  { src: '/images/hero/hero-main.png', eyebrow: '사물인터넷(IoT) 디바이스 영역 강화를 위한 전문 맞춤형 컨설팅 서비스', title: 'IoT 디바이스 관리 플랫폼', desc: '구체적인 요구사항을 정확하게 반영한 디바이스 플랫폼 솔루션으로 제공합니다.' },
];

/* ── 회사 소개: 통계 / 경영 이념 ── */
export const ABOUT_STATS = [
  { number: '30+', label: '임베디드 컴퓨팅 경력' },
  { number: '487+', label: '프로젝트 납품' },
  { number: '300+', label: '고객 기관' },
  { number: '9', label: '글로벌 기술 파트너' },
];

export const ABOUT_PHILOSOPHY = [
  { num: '01', title: '고객 만족', desc: '우리는 고객의 성공을 사업의 중심에 둡니다. 모든 제품, 모든 프로젝트, 모든 지원은 한 가지 기준으로 평가됩니다 — 기대를 뛰어넘었는가? 300개 이상의 기관 고객과 487건 이상의 프로젝트 납품이 성과에 대한 우리의 끊임없는 헌신을 보여줍니다.' },
  { num: '02', title: '소통 중심', desc: '기술 파트너십은 투명성과 신뢰 위에서 성장합니다. 우리는 고객 및 글로벌 파트너 모두와 열린, 능동적인 소통을 유지하여 요구사항을 정확히 이해하고, 일정을 준수하며, 문제가 되기 전에 과제를 해결합니다.' },
  { num: '03', title: '기술 중심', desc: '본질적으로 우리는 엔지니어입니다. 지속적으로 R&D에 투자하고, 임베디드 플랫폼 전반에 걸친 깊은 기술 전문성을 유지하며, 업계의 변화를 앞서갑니다. VxWorks BSP 포팅부터 SIL4 인증 안전 시스템까지, 우리의 기술적 깊이가 곧 경쟁력입니다.' },
];

/* ── 파트너사 카드 ── */
export const PARTNERS = [
  { name: 'Abaco Systems', logo: '/images/partners/abaco.png', url: 'https://www.abaco.com', category: 'Defense-Grade Embedded', desc: '국방·항공우주용 견고한 VPX/VME 보드 및 임베디드 신호 처리 플랫폼.' },
  { name: 'HIMA', logo: '/images/partners/hima.png', url: 'https://www.hima.com', category: 'Railway Safety (SIL4)', desc: 'TÜV SÜD SIL4 인증 ControlSafe™ 철도 안전·신호 제어 플랫폼.' },
  { name: 'Wind River', logo: '/images/partners/windriver.png', url: 'https://www.windriver.com', category: 'RTOS & Software', desc: 'VxWorks, Wind River Linux, Simics 등 임베디드 운영체제·소프트웨어.' },
  { name: 'One Stop Systems', logo: '/images/partners/oss.png', url: 'https://www.onestopsystems.com', category: 'PCIe Expansion & GPU', desc: '고밀도 GPU 확장 섀시, PCIe 스위칭, 고성능 NVMe 스토리지.' },
  { name: 'RTI', logo: '/images/partners/rti.png', url: 'https://www.rti.com', category: 'DDS Middleware', desc: 'Connext DDS 실시간 통신 미들웨어.' },
  { name: 'OKTAL-SE', logo: '/images/partners/oktalse.png', url: 'https://www.oktal-se.fr', category: 'Sensor Simulation', desc: 'EO/IR/RF 센서 모델링·시뮬레이션 (SE-Workbench).' },
  { name: 'Cambridge Pixel', logo: '/images/partners/cambridge-pixel.png', url: 'https://www.cambridgepixel.com', category: 'Radar Processing', desc: 'SPx 레이더 신호 처리 및 디스플레이 솔루션.' },
  { name: 'Pentek', logo: '/images/partners/pentek.png', url: 'https://www.pentek.com', category: 'Data Conversion & SDR', desc: '고성능 데이터 변환 및 소프트웨어 정의 라디오(SDR) 보드.' },
];

/* ── 분야별 제품 상세 (products/:category) ── */
export const CATEGORY_PRODUCTS = {
  military: {
    title: '국방 & 항공우주',
    intro: '정밀 타격, C2, 감시, 무인 체계 등 가장 가혹한 운용 환경을 위해 특별히 제작된 견고한 VPX/VME 보드 및 신호 처리 플랫폼.',
    products: [
      { name: 'Form Factor — Abaco Systems', spec: 'VME · VPX 3U/6U · CompactPCI · PMC · XMC · FMC/FMC+', image: '/images/products/form-factor.png' },
      { name: 'Embedded Board Signal Processing', spec: 'Jade · Cobalt · Onyx · Talon · Flexor · Spark', image: '/images/products/hpc-servers.png' },
      { name: 'RTOS — Wind River', spec: 'VxWorks · Wind River Linux · VxWorks 653 Cert', image: '/images/products/hima-railway.png' },
      { name: 'Middleware — RTI Connext DDS', spec: 'Professional · Secure WAN · Micro · Cert' },
      { name: 'Radar Processing — Cambridge Pixel', spec: 'SPx Server · HPx 고성능 레이더 신호 처리' },
      { name: 'Sensor Modeling & Simulation — OKTAL-SE', spec: 'EO/IR · RF · Active EO · GNSS · 3D Terrain · APIs' },
    ],
  },
  railway: {
    title: '철도 교통',
    intro: 'CBTC, 연동(interlocking), 열차 제어를 위한 TÜV SÜD SIL4 인증 HIMA ControlSafe™ 플랫폼 — 철도 신호 분야 최고 수준의 안전 무결성을 제공합니다.',
    products: [
      { name: 'HIMA HiMax System', spec: '열차 관제 센터를 위한 유연한 COTS 제어 · CBTC · PTC · ATP · ATO · ATS', image: '/images/products/hima-railway.png' },
      { name: 'HIMA ControlSafe™ Platform', spec: 'ControlSafe CCC · ControlSafe EXB · SIL3/SIL4 Certified', image: '/images/products/hima-railway.png' },
      { name: 'RTOS — Wind River', spec: 'VxWorks · VxWorks 653 Cert · ISaGRAF', image: '/images/products/hima-railway.png' },
      { name: 'Industrial PCs for Railway', spec: '신호 표시 제어 · 역사 HMI · 선로변(trackside) 시스템', image: '/images/products/fanless-pc.png' },
    ],
  },
  industrial: {
    title: '산업 자동화',
    intro: '공장 자동화, 공정 제어, 반도체 제조, 품질 검사를 위한 팬리스 산업용 PC, 네트워크 어플라이언스, IoT 플랫폼.',
    products: [
      { name: 'Industrial PCs & Fanless Industrial PCs', spec: 'Boxtype · Rackmount · Server · Desktop · Wallmount · Panel', image: '/images/products/fanless-pc.png' },
      { name: 'Device Cloud & IoT — Wind River', spec: 'Helix Virtualization · Simics · Software Defined Infrastructure' },
      { name: 'RTOS — Wind River', spec: 'VxWorks · Wind River Linux · ISaGRAF', image: '/images/products/hima-railway.png' },
      { name: 'RAM Module', spec: '임베디드 시스템용 산업용 등급 메모리', image: '/images/products/ram-module.png' },
      { name: 'CPU Processor', spec: '산업용 플랫폼을 위한 Intel & AMD 프로세서', image: '/images/products/cpu-processor.png' },
      { name: 'HDD & Storage', spec: '산업용 등급 HDD 및 SSD', image: '/images/products/hdd-2tb.png' },
      { name: 'Motherboard', spec: '산업용 & 임베디드 메인보드', image: '/images/products/motherboard.png' },
    ],
  },
  telecom: {
    title: '통신 & 네트워킹',
    intro: '방화벽, VPN, UTM, 로드 밸런싱을 위한 Intel/AMD 기반 네트워크 어플라이언스와 데이터센터·통신 인프라용 고성능 NIC 어댑터.',
    products: [
      { name: 'Network Appliance', spec: 'Entry · Mid · High-end · Server · Custom · NIC Adapter' },
      { name: 'SMART Embedded Computing', spec: 'AdvancedMC · MicroTCA · ATCA · COM Express' },
      { name: 'Device Cloud & IoT — Wind River', spec: 'Helix Virtualization · Simics · Software Defined Infrastructure' },
      { name: 'Rackmount & Server Systems', spec: '1U/2U/4U Rackmount · Tower Server · 네트워크 보안', image: '/images/products/fanless-pc.png' },
    ],
  },
  sensor: {
    title: '센서 모델링 & 시뮬레이션',
    intro: '국방·항공우주 분야의 HWIL, MITL, 훈련 환경을 위한 OKTAL-SE의 고정밀 EO/IR/RF 센서 시뮬레이션.',
    products: [
      { name: 'SE-Workbench-EO', spec: 'HWIL 시험을 위한 실시간 전자광학(EO) 및 적외선(IR) 장면 생성' },
      { name: 'SE-Workbench-RF', spec: '레이더 및 전자전(EW) 환경을 위한 RF 센서 시뮬레이션' },
      { name: 'SE-RAY-SAR', spec: '합성개구레이더(SAR) 영상 시뮬레이션 및 분석' },
      { name: 'SE-FAST-HWIL', spec: '고속 Hardware-In-the-Loop 시뮬레이션 엔진' },
      { name: 'Active EO & GNSS Simulation', spec: '능동형 전자광학 센서 및 GNSS 신호 시뮬레이션' },
      { name: '3D Terrain & Scene Database', spec: '실시간 3D 지형 생성 · 건물 모델 · 특수 효과 · APIs' },
    ],
  },
  hpc: {
    title: '고성능 컴퓨팅 (HPC)',
    intro: '머신러닝, 금융 분석, 군사, 의료 영상, 과학 연구를 위한 고밀도 GPU 서버 및 PCIe 확장 시스템.',
    products: [
      { name: 'GPU Servers', spec: 'AI & 딥러닝을 위한 고밀도 멀티 GPU 컴퓨팅 플랫폼', image: '/images/products/hpc-servers.png' },
      { name: 'GPU Desktop & Appliances', spec: '개발 및 추론을 위한 워크스테이션급 GPU 플랫폼', image: '/images/products/hpc-servers.png' },
      { name: 'PCIe Expansion — One Stop Systems', spec: 'GPU 확장 섀시 · PCIe 스위칭 · 고성능 NVMe 스토리지' },
      { name: 'Video Acceleration Platform', spec: '하드웨어 가속 영상 인코딩·디코딩·트랜스코딩' },
    ],
  },
};

/* ── 교육 과정 ── */
export const COURSES = [
  { name: 'Workbench 4 (VxWorks 7) 정기 교육', fee: '1,300,000원', duration: '5일' },
];
export const EDU_EMAIL = 'service@acetec-korea.co.kr';
